// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import VueResource from 'vue-resource'

Vue.use(BaiduMap, {
  ak: 'fQdfuLkLFZmkOlMj4Ue4ym36PqM3hRu4'
  //百度地图开发者平台申请的密钥http://lbsyun.baidu.com/apiconsole/key */
})
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueResource)
Vue.prototype.$img = 'https://img.czjuzhi.com/'


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js